import axios from "axios";
import {
  ResponseItem,
  ResponseList,
  ResponseRemove,
} from "../../models/clientModels/interfaces/Response";
import * as Params from "../../models/clientModels/interfaces/apiParams";

import {CheckItemParams, WPCheckItem} from "../../models/serverModels/permission/WPCheckItem";

const rootApi = process.env.REACT_APP_API_KEY;

const permission = axios.create({
  baseURL: rootApi,
});

export const getList = async (params: CheckItemParams): Promise<ResponseList<WPCheckItem>> =>
  permission({
    url: "/GetCheckItemList",
    method: "get",
    params,
  }).then((res) => res.data);

export const getItem = async (params: Params.GetItem): Promise<ResponseItem<WPCheckItem>> =>
  permission({
    url: `/EvaluationCheckItem/${params.id}`,
    method: "get",
    params,
  }).then((res) => res.data);

export const create = async (
  params: Params.Create<WPCheckItem>
): Promise<ResponseItem<WPCheckItem>> =>
  permission({
    url: `/EvaluationCheckItem`,
    method: "post",
    data: params,
  }).then((res) => res.data);

export const remove = async (params: Params.Remove): Promise<ResponseRemove> =>
  permission({
    url: `/EvaluationCheckItem/${params.id}`,
    method: "delete",
    data: params,
  }).then((res) => res.data);

export const update = async (
  params: Params.Update<WPCheckItem>
): Promise<ResponseItem<WPCheckItem>> =>
  permission({
    url: `/EvaluationCheckItem/${params.id}`,
    method: "put",
    data: params,
  }).then((res) => res.data);
